import Vue from "vue";
/**
 * setter
 * @method setCampaign
 * @method setTitle
 * @method setTag
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onCLickConfirm
 * @method onClickCancel
 * event
 * @event sendCallbackConfirm
 * @event sendCallbackCancel
 */
export function ConfirmRedeemModalController () {
    this.campaign = '';
    this.tag = '';
    this.busModal = new Vue();

    this.callbackConfirm = null;
    this.callbackCancel = null;

    //#region setter
    this.setCampaign = function (campaign) {
        this.campaign = campaign;
        return this;
    };
    this.setTag = function (tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function () {
        this.campaign = null;
        this.tag = '';
        this.callbackConfirm = null;
        this.callbackCancel = null;
        return this;
    };
    //#endregion setter
    //#region action
    this.show = function () {
        var config = {
            campaign: this.campaign,
            tag: this.tag,
            theme: this.theme
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function () {
        this.busModal.$emit('hide');
    };
    //#endregion action
    //#region event
    this.onClickConfirm = function (callback) {
        if (typeof callback == 'function') {
            this.callbackConfirm = callback;
        }
    };
    this.sendCallbackConfirm = function (data) {
        if (typeof this.callbackConfirm == 'function') {
            this.callbackConfirm(data);
        }
    };
    this.onCallbackCancel = function (callback) {
        if (typeof callback == 'function') {
            this.callbackCancel = callback;
        }
    };
    this.sendCallbackCancel = function (data) {
        if (typeof this.callbackCancel == 'function') {
            this.callbackCancel(data);
        }
    };
    //#endregion event
}
